import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const products = [
  {
    name: "AppLaunch Pro",
    tagline: "Your end-to-end launch platform",
    desc: "A comprehensive SaaS platform for managing software product launches — from backlog and sprint planning to release tracking and post-launch analytics.",
    tags: ["SaaS", "Project Management", "Analytics"],
    color: "#0073E5",
    img: "https://readdy.ai/api/search-image?query=modern%20macbook%20pro%20on%20a%20minimalist%20white%20desk%20displaying%20a%20sleek%20project%20management%20dashboard%20with%20colorful%20kanban%20columns%20sprint%20cards%20and%20charts%20soft%20natural%20daylight%20coming%20from%20the%20side%20clean%20tech%20workspace&width=700&height=500&seq=applaunch-new-31&orientation=landscape",
  },
  {
    name: "ClientHub CRM",
    tagline: "Relationships made simple",
    desc: "A lightweight but powerful CRM tool built for agencies and small businesses. Track leads, manage deals, automate follow-ups, and close more clients — without the bloat.",
    tags: ["CRM", "Automation", "Lead Tracking"],
    color: "#D4F419",
    img: "https://readdy.ai/api/search-image?query=open%20laptop%20on%20a%20bright%20wooden%20desk%20showing%20a%20CRM%20contacts%20dashboard%20with%20deal%20pipeline%20funnel%20colorful%20lead%20cards%20and%20activity%20feed%20warm%20cozy%20office%20environment%20natural%20light%20professional%20lifestyle%20photo&width=700&height=500&seq=clienthub-new-32&orientation=landscape",
  },
  {
    name: "FlowCommerce",
    tagline: "E-commerce built for growth",
    desc: "A modular e-commerce toolkit that integrates with existing stores or powers standalone storefronts. Includes inventory management, promotions engine, and real-time analytics.",
    tags: ["E-commerce", "Inventory", "Analytics"],
    color: "#E4D6EA",
    img: "https://readdy.ai/api/search-image?query=elegant%20iMac%20on%20a%20stylish%20desk%20showing%20an%20ecommerce%20admin%20storefront%20with%20product%20grid%20cards%20shopping%20cart%20revenue%20chart%20and%20inventory%20panel%20soft%20pastel%20studio%20background%20minimal%20modern%20interior%20design&width=700&height=500&seq=flowcommerce-new-33&orientation=landscape",
  },
  {
    name: "Insight Dash",
    tagline: "Data you can act on",
    desc: "A real-time business intelligence dashboard that connects to your data sources and surfaces the metrics that matter. No SQL required — just clear, visual answers.",
    tags: ["BI", "Data Visualisation", "Reporting"],
    color: "#F4971E",
    img: "https://readdy.ai/api/search-image?query=widescreen%20monitor%20on%20a%20dark%20modern%20desk%20displaying%20a%20business%20intelligence%20dashboard%20with%20glowing%20line%20graphs%20donut%20charts%20KPI%20tiles%20and%20heatmaps%20deep%20navy%20background%20with%20amber%20accent%20lights%20cinematic%20tech%20photography&width=700&height=500&seq=insightdash-new-34&orientation=landscape",
  },
];

export default function OurProducts() {
  return (
    <div className="min-h-screen font-sans" style={{ backgroundColor: "#FEF7EB" }}>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-40 pb-24 px-6 md:px-16 overflow-hidden">
        <div
          className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full opacity-25 pointer-events-none"
          style={{ backgroundColor: "#F4971E", filter: "blur(100px)" }}
        />
        <div className="max-w-7xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: "#0073E5" }}>
            Our Products
          </p>
          <h1 className="text-5xl md:text-7xl font-bold text-black leading-tight max-w-3xl mb-8">
            Products built<br />to last.
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl leading-relaxed">
            Alongside our bespoke development work, we build and maintain our own suite of digital products.
            These tools are battle-tested, scalable, and ready to power your business from day one.
          </p>
        </div>
      </section>

      {/* Products */}
      <section className="px-6 md:px-16 pb-24">
        <div className="max-w-7xl mx-auto space-y-8">
          {products.map((p, i) => (
            <div
              key={p.name}
              className={`rounded-2xl overflow-hidden flex flex-col ${i % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"}`}
              style={{ backgroundColor: p.color }}
            >
              <div className="flex-1 p-10 md:p-14 flex flex-col justify-center">
                <span className="text-xs font-semibold uppercase tracking-widest opacity-50 mb-3"
                  style={{ color: p.color === "#0073E5" ? "white" : "black" }}>
                  Product
                </span>
                <h2 className="text-3xl md:text-4xl font-bold mb-2"
                  style={{ color: p.color === "#0073E5" ? "white" : "black" }}>
                  {p.name}
                </h2>
                <p className="font-medium mb-4 opacity-70"
                  style={{ color: p.color === "#0073E5" ? "white" : "black" }}>
                  {p.tagline}
                </p>
                <p className="text-sm leading-relaxed mb-6 opacity-70 max-w-md"
                  style={{ color: p.color === "#0073E5" ? "white" : "black" }}>
                  {p.desc}
                </p>
                <div className="flex flex-wrap gap-2 mb-8">
                  {p.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs font-medium px-3 py-1 rounded-full"
                      style={{
                        backgroundColor: p.color === "#0073E5" ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.1)",
                        color: p.color === "#0073E5" ? "white" : "black",
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <Link
                  to="/contact-us"
                  className="inline-flex items-center gap-2 font-semibold px-6 py-3 rounded-full text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap self-start"
                  style={{
                    backgroundColor: p.color === "#0073E5" ? "#D4F419" : "black",
                    color: p.color === "#0073E5" ? "black" : "white",
                  }}
                >
                  Learn more
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="lg:w-[45%] h-64 lg:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={p.img}
                  alt={p.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="px-6 md:px-16 pb-24">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">Need a custom solution?</h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto mb-8">
            Our products are just the beginning. We build fully tailored software for your specific business requirements.
          </p>
          <Link
            to="/our-services"
            className="inline-flex items-center gap-2 text-white font-semibold px-8 py-4 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap text-sm"
            style={{ backgroundColor: "#0073E5" }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#005bbf")}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#0073E5")}
          >
            Explore our services
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
